module.exports = __webpack_public_path__ + "static/img/cloud_logo_white.a71b8d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloud_logo_white.svg
// module id = flbz
// module chunks = 0